<form #form="ngForm"
      novalidate="true"
      method="post"
      class="p-b-5-s">

    <input-wrap>
        <input class="input"
               type="text"
               name="sender_name"
               [muiInput]="'Your name' | translate"
               [attr.placeholder]="'Press enter to confirm' | translate"
               required
               [(ngModel)]="data.sender_name">
    </input-wrap>

    <!-- Recipient Name -->
    <input-wrap class="w-12 m-t">
        <input class="input"
               type="text"
               name="recipient_name"
               [muiInput]="'Recipient\'s name' | translate"
               [attr.placeholder]="'Press enter to confirm' | translate"
               required
               [(ngModel)]="data.recipient_name">
    </input-wrap>

    <!-- Email -->
    <input-wrap class="w-12 m-t">
        <input class="input"
               type="email"
               name="recipient_email"
               [muiInput]="'Recipient\'s email address' | translate"
               [attr.placeholder]="'Press enter to confirm' | translate"
               required
               [(ngModel)]="data.recipient_email">
    </input-wrap>

    <!-- Message -->
    <input-wrap class="w-12 m-t">
        <input class="input"
               type="text"
               name="message"
               [muiInput]="'Message' | translate"
               required
               [(ngModel)]="data.message">
    </input-wrap>

    <!-- submit -->
    <action class="w-12 button m-b-2-s m-t-8 m-t-7-s"
            (click)="submit()"
            [status]="status">
        <span translate>Share</span>
    </action>
    <!-- action result -->
    <result class="w-12 fs-4"
            [status]="status"
            [success]="'The message was sent' | translate"></result>
</form>